module.exports = require("./ar-QA.js");